// Browser auto-translate (Chrome/Edge Google Translate) and some extensions wrap React's
// text nodes in <font> tags. React then crashes with "Failed to execute 'insertBefore'/'removeChild'
// on 'Node'". Make both calls tolerant so the app keeps working while a page is translated.
// See https://github.com/facebook/react/issues/11538
if (typeof Node === "function" && Node.prototype && !Node.prototype.__dmTranslatePatched) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function removeChild(child) {
    if (child.parentNode !== this) {
      if (child.parentNode) return originalRemoveChild.call(child.parentNode, child);
      return child;
    }
    return originalRemoveChild.call(this, child);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function insertBefore(newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (referenceNode.parentNode) return originalInsertBefore.call(referenceNode.parentNode, newNode, referenceNode);
      return originalInsertBefore.call(this, newNode, null);
    }
    return originalInsertBefore.call(this, newNode, referenceNode);
  };

  Node.prototype.__dmTranslatePatched = true;
}
